import React from 'react';

const SkeletonLoader = props => {
  const { viewport, noOfSlides } = props;

  let slideWidth = viewport && noOfSlides ? viewport.width / noOfSlides - 18 : 276;
  const slideViewBoxWidth = viewport && noOfSlides && viewport.width / noOfSlides;

  if (slideWidth < 0) {
    slideWidth = 462;
  }

  return (
    <div
      style={{
        borderRadius: '8px',
        backgroundColor: '#f0f0f0',
        width: `${slideWidth}px`,
        height: '334px',
      }}
    />
  );
};

export default SkeletonLoader;
